export default __webpack_public_path__ + "static/media/warning.13594e31.svg";